export default __webpack_public_path__ + "static/media/step1.152a2c90.mov";